module.exports = __webpack_public_path__ + "static/media/discordBanner.7a7979a8.png";